import { render, staticRenderFns } from "./AppQuickActions.vue?vue&type=template&id=571bf65c&scoped=true&"
import script from "./AppQuickActions.vue?vue&type=script&lang=js&"
export * from "./AppQuickActions.vue?vue&type=script&lang=js&"
import style0 from "./AppQuickActions.vue?vue&type=style&index=0&id=571bf65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bf65c",
  null
  
)

export default component.exports